import { EntityTypes } from "./enums";

export interface AccessCode {
    accessCode: string;
    email: string;
    entityType: EntityTypes;
    url?: string;
    firstName?: string;
    lastName?: string;
    created: number;
    expires: number;
}

export interface CreateAccessCodeInput {
    email: string;
    url?: string;
    entityType: EntityTypes;
    firstName?: string;
    lastName?: string;
}

export interface GetAccessCodeUrlInput {
    accessCode: string;
    email: string;
}

// JSON Schema for GETAccessCodeUrlInput
export const GetAccessCodeUrlInputSchema = {
    type: 'object',
    properties: {
        accessCode: { type: 'string', minLength: 6, maxLength: 6 },
        email: { type: 'string', format: 'email' },
    },
    required: ['accessCode', 'email'],
};